if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector('.js-results-container');
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector('.js-message-error');
      this.errorMessageText = this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');
      var searchBestsellers = document.querySelector('.search-drawer__bestsellers');

      /* INPUT HANDLER */
      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if (window.innerWidth < 990) searchDrawerContent.style.height = 'auto';
            if (searchSuggestions) searchSuggestions.style.display = 'block';
            if (searchBestsellers) searchBestsellers.style.display = 'block';

            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);

          if (window.innerWidth <= 990) searchDrawerContent.style.height = '100%';
          if (searchSuggestions) searchSuggestions.style.display = 'none';
          if (searchBestsellers) searchBestsellers.style.display = 'none';
        }, 300);
      });

      /* ESCAPE HANDLER */
      this.input.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;

        if (!this.input.value) {
          if (this.drawer) this.drawer.parentElement.parentElement.toggleDrawer();
          return;
        }

        this.close();
      });

      /* CLEAR BUTTON */
      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if (searchSuggestions) searchSuggestions.style.display = 'block';
        if (searchBestsellers) searchBestsellers.style.display = 'block';

      });
    }

    /* ==============================
       GET SEARCH RESULTS
    ============================== */
    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) return;
        if (!response.ok) throw new Error(response.status);

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // === ARROWS WITH DISABLED STATE ===
        setTimeout(() => {
          const grid = this.resultsContainer.querySelector('.predictive-search__grid');
          const btnPrev = this.resultsContainer.querySelector('.predictive-arrow-prev');
          const btnNext = this.resultsContainer.querySelector('.predictive-arrow-next');

          if (!grid || !btnPrev || !btnNext) return;

          // Prevent navigation
          [btnPrev, btnNext].forEach(btn => {
            btn.addEventListener('click', e => {
              e.preventDefault();
              e.stopPropagation();
            });
          });

          // Scroll helpers
          const updateArrowState = () => {
            const maxScroll = grid.scrollWidth - grid.clientWidth;

            btnPrev.disabled = grid.scrollLeft <= 5;                  // start
            btnNext.disabled = grid.scrollLeft >= maxScroll - 5;      // end
          };

          // Initial state
          updateArrowState();

          btnNext.addEventListener('click', () => {
            grid.scrollBy({ left: 350, behavior: 'smooth' });
            setTimeout(updateArrowState, 300);
          });

          btnPrev.addEventListener('click', () => {
            grid.scrollBy({ left: -350, behavior: 'smooth' });
            setTimeout(updateArrowState, 300);
          });

          // Update on manual scroll (mouse / touchpad)
          grid.addEventListener('scroll', updateArrowState);

        }, 50);

        // Quick cart triggers
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    /* ==============================
       OPEN
    ============================== */
    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    /* ==============================
       CLOSE
    ============================== */
    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}